import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import CanonicalTag from '@/components/CanonicalTag';
import aduRequirementsImage from '@/assets/adu-requirements.jpg';

const WhatAreTheRequirementsForADUCalifornia = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  return (
    <>
      <CanonicalTag url="https://www.udaadu.com/adu-requirements-california" />
      
      {/* Calendly Modal */}
      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative bg-white rounded-lg w-full max-w-4xl h-full max-h-[90vh]">
            <button 
              onClick={closeCalendlyModal} 
              className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
            >
              ✕
            </button>
            <iframe 
              src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              title="Schedule a meeting"
            />
          </div>
        </div>
      )}
      
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <main className="container mx-auto px-4 py-8">
          {/* Hero Section */}
          <div className="mb-12">
            <img 
              src={aduRequirementsImage} 
              alt="California ADU requirements blueprints" 
              className="w-full h-64 md:h-96 object-cover rounded-lg mb-8"
            />
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#E4683B' }}>
              What Are the Requirements for an ADU in California?
            </h1>
            
            <p className="text-lg md:text-xl text-white leading-relaxed mb-8">
              Understand comprehensive ADU requirements in California including size limits, utilities, safety features, and compliance standards.
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-12">
            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Size and Design Requirements
              </h2>
              <p className="text-white leading-relaxed mb-6">
                California ADUs must be between 150-1,200 square feet, with specific size calculations based on bedrooms and lot size. Detached ADUs can be up to 1,200 sq ft, while attached ADUs are limited to 50% of the primary dwelling's floor area. All ADUs require minimum 7-foot ceilings and proper egress windows.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Essential Utilities and Infrastructure
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Every California ADU must include independent utilities: separate electrical panels, plumbing systems, and HVAC installations. Required features include a full kitchen with sink and cooking facilities, complete bathroom, and adequate electrical service. Water, sewer, and gas connections must meet current building codes.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Safety and Building Code Compliance
              </h2>
              <p className="text-white leading-relaxed mb-6">
                ADUs must meet current California Building Code standards including fire safety, accessibility provisions, and energy efficiency requirements. Required safety features include smoke detectors, carbon monoxide alarms, proper insulation, and emergency egress. Professional architectural plans and building permits are mandatory for compliance.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Frequently Asked Questions
              </h2>
              <div className="text-white leading-relaxed space-y-6">
                <div>
                  <p className="font-semibold mb-2">Q: What is the minimum size requirement for a California ADU?</p>
                  <p>A: 150 square feet minimum, with maximum sizes varying by type and lot characteristics.</p>
                </div>
                
                <div>
                  <p className="font-semibold mb-2">Q: Do ADUs require separate utility connections?</p>
                  <p>A: Yes, independent electrical, plumbing, and HVAC systems are required for all ADUs.</p>
                </div>
              </div>
            </section>
          </div>

          {/* Call-to-Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
            <Button 
              onClick={openCalendlyModal}
              className="bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-3 text-lg"
            >
              Book & Schedule
            </Button>
            <Button 
              asChild
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground px-8 py-3 text-lg"
            >
              <Link to="/landing">Learn More</Link>
            </Button>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default WhatAreTheRequirementsForADUCalifornia;